import React from 'react';
import Box from '@mui/material/Box';
import { SURFACE, gridBg } from './theme.js';

export function HeroSection({ children }) {
    return (
        <Box
            component="section"
            sx={{
                ...gridBg(SURFACE.lavender),
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                pt: { xs: 5, md: 7.5 },
                pb: { xs: 5, md: 7 },
                borderBottom: '1px solid rgba(26,23,38,0.07)',
                overflow: 'hidden',
            }}
        >
            {children}
        </Box>
    );
}
